export const LOGIN = 'LOGIN';
export const HOME = 'HOME';
export const JOBS = 'JOBS';
export const DEFAULT = 'DEFAULT';
export const JOBS_TV = 'JOBS_TV';
export const BFIX_DASH = 'BFIX_DASH';
export const AIR_ROAD_JOBS = 'AIR_ROAD_JOBS';
export const AIR_ROAD_BOOKED = 'AIR_ROAD_BOOKED';
export const JOB_TICKETS = 'JOB_TICKETS';
export const JOB_BOOKING = 'JOB_BOOKING';
export const BOOKING_COMPLIANCE = 'BOOKING_COMPLIANCE';
export const PARCEL_JOB_BOOKING = 'PARCEL_JOB_BOOKING';
export const NEW_JOB_BOOKING = 'NEW_JOB_BOOKING';
export const CLONE_JOB_BOOKING = 'CLONE_JOB_BOOKING';
export const ADVANCED_JOB_BOOKING = 'ADVANCED_JOB_BOOKING';
export const WAREHOUSE_SAME_WH_JB = 'WAREHOUSE_JOB_BOOKING';
export const WAREHOUSE_TO_WH_JB = 'WAREHOUSE_TO_WH_JOB_BOOKING';
export const SITE_INSPECTION_JOB_BOOKING = 'SITE_INSPECTION_JOB_BOOKING';
export const BREAK_FIX_JOB_BOOKING = 'BREAK_FIX_JOB_BOOKING';
export const DRAFT_ADVANCED_JOB_BOOKING = 'DRAFT_ADVANCED_JOB_BOOKING';
export const SPREADSHEET_JOB_BOOKING = 'SPREADSHEET_JOB_BOOKING';
export const SPREADSHEET_B2B_BOOKING = 'SPREADSHEET_B2B_BOOKING';
export const SEARCH = 'SEARCH';
export const SEARCH_POSTCODE = 'SEARCH_POSTCODE';
export const DRAFT_JOB_BOOKING = 'DRAFT_JOB_BOOKING';
export const WAREHOUSE_QUANT_PAGE = 'WAREHOUSE_QUANT_PAGE';
export const DETAILED_QUERY_JOB = 'DETAILED_QUERY_JOB';
export const DETAILED_PARAM_JOB = 'DETAILED_PARAM_JOB';
export const TICKET_FROM_THE_SERVICE_DESK = 'TICKET_FROM_THE_SERVICE_DESK';
export const SERVICE_DESK_TICKET = 'SERVICE_DESK_TICKET';
export const LIST_QUOTES = 'LIST_QUOTES';
export const NEW_QUOTE = 'NEW_QUOTE';
export const DETAILED_QUOTE = 'DETAILED_QUOTE';
export const SCHEDULER_BOARD = 'SCHEDULER_BOARD';
export const SCHEDULER_BOARD_LOGS = 'SCHEDULER_BOARD_LOGS';
export const SCHEDULER = 'SCHEDULER';
export const SCHEDULER_SHIFTS = 'SCHEDULER_SHIFTS';
export const PROFILE = 'PROFILE';
export const ADDRESS_BOOK = 'ADDRESS_BOOK';
export const REPORTS = 'REPORTS';
export const RUN_SHEET = 'RUN_SHEET';
export const KPI_REPORT = 'KPI_REPORT';
export const DRIVER_REPORT = 'DRIVER_REPORT';
export const TOMORROW_REPORT = 'TOMORROW_REPORT';
export const WEEKLY_STATS_REPORT = 'WEEKLY_STATS_REPORT';
export const AM_PM_JOBS = 'AM_PM_JOBS';
export const ETA_REPORT = 'ETA_REPORT';
export const BOOKED_JOBS = 'BOOKED_JOBS';
export const SUBURBS = 'SUBURBS';
export const MAILBOX_TEST = 'MAILBOX_TEST';
export const INITIAL_ERROR = 'INITIAL_ERROR';
export const PAGE_ERROR = 'PAGE_ERROR';
export const LOCATIONS = 'LOCATIONS';
export const JOBHISTORY = 'JOBHISTORY';
export const TRANSFERS = 'TRANSFERS';
export const SMS_DAILY_FOLLOW_UP = 'SMS_DAILY_FOLLOW_UP';
export const SMS_HISTORY = 'SMS_HISTORY';
export const NEXT_DAY_STOPS = 'NEXT_DAY_STOPS';
export const TECHNICIANS = 'TECHNICIANS';
export const TECHNICIANS_CATALOG = 'TECHNICIANS_CATALOG';
export const DRIVER_RETRANSMIT = 'DRIVER_RETRANSMIT';
export const NEWSLETTER = 'NEWSLETTER';
export const QUANTS_CART_PAGE = 'QUANTS_CART_PAGE';
export const UNINVOICED_JOBS = 'UNINVOICED_JOBS';
export const OUTGOING_MACHINES = 'OUTGOING_MACHINES';
export const PERMANENT_JOBS_LIST = 'PERMANENT_JOBS_LIST';
export const PERMANENT_JOB_DETAIL = 'PERMANENT_JOB_DETAIL';
export const PERMANENT_JOB_BOOKING = 'PERMANENT_JOB_BOOKING';
